import { NotificationHeader } from '@/app/NotificationHeader';
import { useIsAuthenticated } from '@/app/core/auth';
import { useDefaultLayoutState } from '@/app/store';
import {
  AiOutlineCloseCircle,
  AiOutlineMenuUnfold,
} from 'react-icons/ai/index.js';
import { ReactNode } from 'react';
import { Box, Divider, Flex, Grid, GridItem, Icon } from '@chakra-ui/react';

export interface DefaultLayoutProps {
  footer: ReactNode;
  mainNav: ReactNode;
  generalNav: ReactNode;
  logo: ReactNode;
  children?: ReactNode;
}

const MainNavToggler = () => {
  const { isSiderCollapsed, toggleSider } = useDefaultLayoutState();
  return (
    <Flex w={20} justifyContent='center'>
      <Flex
        alignItems='center'
        color='primary'
        cursor='pointer'
        onClick={(e) => {
          e.preventDefault();
          toggleSider(!isSiderCollapsed);
        }}
      >
        <Icon
          as={isSiderCollapsed ? AiOutlineMenuUnfold : AiOutlineCloseCircle}
          fontSize='2xl'
        />
      </Flex>
    </Flex>
  );
};

export const DefaultLayout = (props: DefaultLayoutProps) => {
  const isAuthed = useIsAuthenticated();
  return (
    <Flex as='section' className='app-default-layout' flexDir='column'>
      {isAuthed && <NotificationHeader />}
      <Box as='header' h={16} className='main-header'>
        <Grid templateColumns='repeat(2, 1fr)'>
          <GridItem>
            <Box className='logo-container'>
              <MainNavToggler />
              {props.logo}
            </Box>
          </GridItem>
          <GridItem>
            <Grid>
              <GridItem>{props.generalNav}</GridItem>
            </Grid>
          </GridItem>
        </Grid>
      </Box>
      <Flex as='section' flexDir='row' minH='100vh'>
        {props.mainNav}
        <Flex as='section' flexDir='column' w='100%' bg='gray.100'>
          <Box as='main' my={0} mx={4} h='100%'>
            <div className='page-content'>{props.children}</div>
          </Box>
          <Box as='footer' fontSize='sm' px={12} pb={6}>
            <Divider borderColor='gray.400' w='100%' my={6} />
            {props.footer}
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};

DefaultLayout.whyDidYouRender = true;
